import React from "react";
import { ButtonGroup, Dropdown, DropdownButton } from "react-bootstrap";
import Accompanists from "./Accompanists";
import { CompetitionCategories } from "./Categories";


const AdditionalOptions = React.memo(
  ({ setFormData, selectedCategory, setSelectedCategory, districts }) => {
    return (
      <div>
        <DropdownButton
          as={ButtonGroup}
          id="dropdown-button-drop-down"
          drop="down"
          variant="primary"
          size="md"
          title={
            selectedCategory
              ? CompetitionCategories.find(
                  (cat) => cat.value === selectedCategory
                )?.label || "Select Category"
              : "Select Category"
          }
          className="me-1 mb-1"
          onSelect={(category) => {
            setSelectedCategory(category);
            setFormData((prev) => ({
              ...prev,
              selectedCategory: category,
            }));
          }}
        >
          {CompetitionCategories.map((category) => (
            <Dropdown.Item key={category.value} eventKey={category.value}>
              {category.label}
            </Dropdown.Item>
          ))}
        </DropdownButton>
        {[
          "folkSong",
          "folkDance",
          "classicalSinging",
          "classicalInstrumental",
        ].includes(selectedCategory) && <Accompanists districts={districts} />}
      </div>
    );
  }
);

export default AdditionalOptions;
